import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import React from 'react';
import { MyMetricDefinition } from 'libs/end-to-end/src/my-metric-definition';
import { Responsive } from 'apps/sigma2-ui/src/lib/hooks/useResponsive';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';

export const DisparityOpportunityTitle = (props: {
  treatmentGroup: LevelDefinition;
  metricDefinition: MyMetricDefinition;
  typographyVariant: Responsive<TypographyVariant>;
}) => {
  const language = useLanguage();

  return (
    <S2Typography
      translatedContent={language.disparityOpportunityTitle({
        whiteLabelingSubjectPlural:
          props.metricDefinition.whiteLabeling.subjectPlural,
        metricDisplayName: props.metricDefinition.displayName,
        treatmentGroupDisplayName: props.treatmentGroup.displayName,
      })}
      variant={props.typographyVariant}
      truncate={true}
    />
  );
};
